import {Paper, Stack} from '@mui/material';
import {QuizSession} from '@cp/model';
import QuestionReviewHeader from './QuestionReviewHeader';
import QuestionReviewQuestion from './QuestionReviewQuestion';

interface QuestionsReviewProps {
  session: QuizSession;
}

export default function QuestionsReview({session}: QuestionsReviewProps) {
  const totalQuestions = session.questions.length;

  return (
    <Paper sx={{p: {xs: 2, sm: 3}}} data-testid="questions-review">
      <QuestionReviewHeader totalQuestions={totalQuestions} />

      <Stack spacing={{xs: 1.5, sm: 2}} data-testid="questions-review-list">
        {session.questions.map((question, index) => (
          <QuestionReviewQuestion key={question.id} question={question} index={index} />
        ))}
      </Stack>
    </Paper>
  );
}
